import AbstractTrackingAdapter, { Revenue } from './AbstractTrackingAdapter';

export default class AmplitudeProvider extends AbstractTrackingAdapter {
  amplitude: any;

  constructor(amplitude) {
    super();
    this.amplitude = amplitude;
  }

  logEvent = (eventName: string, eventProperties: any) => {
    this.amplitude.logEvent(eventName, eventProperties);
  };

  revenue = ({ productId, amount, properties }: Revenue) => {
    const revenue = new this.amplitude.Revenue()
      .setProductId(productId)
      .setPrice(amount)
      .setEventProperties(properties);
    this.amplitude.logRevenueV2(revenue);
  };

  setUser = (user: any) => {
    if (!user) return null;
    this.amplitude.setUserId(user.email);
    this.amplitude.setUserProperties({
      id: user.id,
      email: user.email,
      emailVerified: user.emailVerified,
      fullname: user.fullname,
      kyc_level: user.kyc_level
    });
  };
}
